import {
    VuexModule,
    Module,
    Mutation,
    Action,
} from "vuex-module-decorators";

@Module({ namespaced: true })
class Empresas extends VuexModule {

    public listaEmpresas = [] as Array<any>;
    
    @Action({ rawError: true })
    setEmpresaSelecionada(empresa: any) {
        this.context.commit("selecionarEmpresa", empresa.id);
    }

    @Mutation
    selecionarEmpresa(empresaId: number){
        let selIdx = this.listaEmpresas.findIndex(el => el.selected == true);
        if (selIdx >= 0){
            this.listaEmpresas[selIdx].selected = false;
        }

        selIdx = this.listaEmpresas.findIndex(el => el.id == empresaId);
        this.listaEmpresas[selIdx].selected = true;
    }


    @Mutation
    setListaEmpresas(empresas: any){
        this.listaEmpresas = empresas;
        if (this.listaEmpresas.length > 0)
            this.listaEmpresas[0].selected = true;
    }

    get getEmpresas(): Array<any> {
        return this.listaEmpresas;
    }

    get empresaSelecionada(): any {
        const result = this.listaEmpresas.find(el => el.selected == true);
        if (result)
            return result;
        else
            return this.listaEmpresas[0];

    }

}
export default Empresas;

